import { render, staticRenderFns } from "./Homegroup2.vue?vue&type=template&id=106a3aaa&scoped=true&"
import script from "./Homegroup2.vue?vue&type=script&lang=js&"
export * from "./Homegroup2.vue?vue&type=script&lang=js&"
import style0 from "./Homegroup2.vue?vue&type=style&index=0&id=106a3aaa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106a3aaa",
  null
  
)

export default component.exports